import ReactGA from 'react-ga4';

import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import { Checkbox, Slider, Tooltip } from 'antd';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import { TA_D_CLICK_APPLY, TA_D_CLICK_CANCEL, TA_D_CLICK_GEAR, TA_D_CLICK_SHOW_COMM, TA_D_CLICK_SHOW_SUPPLIER, TA_D_CLICK_SLIDER, TA_R_CLICK_APPLY, TA_R_CLICK_CANCEL, TA_R_CLICK_GEAR, TA_R_CLICK_SHOW_COMM, TA_R_CLICK_SHOW_SUPPLIER, TA_R_CLICK_SLIDER } from '@share/constants';
import { FunctionalRootState, isCarsDetailFromPath, isCarsResultsFromPath, isCondoResultsFromPath, isDetailFromPath, isResultsFromPath, RootState } from '@share/utils';
import { marginatorActions, IMenuState } from '@share/store/slices';

import { faGear, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.scss';

interface IProps {
  onOpen?: () => void;
}

export function Marginator(props: IProps) {

  const dispatch = useDispatch();

  const history = useHistory();

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const marginatorStore = useSelector((state: RootState) => state.marginatorStore);
  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  const hotelDetailsStore = useSelector((state: RootState) => state.hotelDetailsStore);
  const reviewBookStore = useSelector((state: RootState) => state.reviewBookStore);
  const condosStore = useSelector((state: RootState) => state.condosStore);
  const condoDetailsStore = useSelector((state: RootState) => state.condoDetailsStore);
  const condoReviewBookStore = useSelector((state: RootState) => state.condoReviewBookStore);
  const carsStore = useSelector((state: RootState) => state.carsStore);
  const carsDetailsStore = useSelector((state: RootState) => state.carsDetailsStore);
  const carsReviewBookStore = useSelector((state: RootState) => state.carsReviewBookStore);

  const { user, account } = loginStore;
  const { hotels } = hotelsStore;
  const { condos } = condosStore;
  const { cars } = carsStore;

  const { bookingSummary } = reviewBookStore;
  const { condoBookingSummary } = condoReviewBookStore;
  const { booking } = carsReviewBookStore;
  const { hotel } = hotelDetailsStore;
  const { condo } = condoDetailsStore;
  const { car } = carsDetailsStore;
  
  const [show, setShow] = useState(false);
  const [showDrop, setShowDrop] = useState(false);
  const [showCommission, setShowCommission] = useState(marginatorStore.showCommissionSelected);
  const [showSupplierCheck, setShowSupplierCheck] = useState(marginatorStore.showSupplierSelected);
  const [showSupplier, setShowSupplier] = useState(false);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(30);
  const [defaultValue, setDefaultValue] = useState(5);
  const [hasChanged, setHasChanged] = useState(false);

  const isSearchHotels = hotelsStore.isSearch;
  const isSearchCondos = condosStore.isSearch;
  const isSearchCars = carsStore.isSearch;

  const isTravelAgentPro = account?.isTravelAgentPro;
  const isCapitalVacations = account?.isCapitalVacations;
  const preferences = account?.preferences;
  const headerFontColor = account?.headerFontColor;

  const isHotelResultPage = useMemo(() => isResultsFromPath(history), [history.location.pathname]);
  const isHotelDetailsPage = useMemo(() => isDetailFromPath(history), [history.location.pathname]);

  const isCondoResultPage = useMemo(() => isCondoResultsFromPath(history), [history.location.pathname]);
  const isCondoDetailsPage = useMemo(() => isCondoResultsFromPath(history), [history.location.pathname]);

  const isCarsResultPage = useMemo(() => isCarsResultsFromPath(history), [history.location.pathname]);
  const isCarsDetailsPage = useMemo(() => isCarsDetailFromPath(history), [history.location.pathname]);

  const isAfterSearchLoadHotels = isHotelResultPage && (isSearchHotels || (hotels && !!hotels.length));
  const isAfterSearchLoadCondos = isCondoResultPage && (isSearchCondos || (condos && !!condos.length));
  const isAfterSearchLoadCars = isCarsResultPage && (isSearchCars || (cars && !!cars.length));
  const isAfterSearchLoad = isAfterSearchLoadHotels || isAfterSearchLoadCondos || isAfterSearchLoadCars;

  const isAfterDetailsLoadHotels = isHotelDetailsPage && !!hotel?.hotelDetails;
  const isAfterDetailsLoadCondos = isCondoDetailsPage && !!condo?.condoDetails;
  const isAfterDetailsLoadCars = isCarsDetailsPage && !!car && !booking;
  const isAfterDetailsLoad = isAfterDetailsLoadHotels || isAfterDetailsLoadCondos || isAfterDetailsLoadCars;

  const showDefault = isAfterSearchLoad || isAfterDetailsLoad;
  const display = showDefault && user && isTravelAgentPro;

  const hasReviewData = bookingSummary || condoBookingSummary || booking;

  const { items }: IMenuState = useSelector((state: FunctionalRootState) => state.navigationMenuStore);

  const handleSetShowMarginator = () => {
    const showMarginator = !hasReviewData && !!display;
    setShow(showMarginator);

    if (showMarginator) {
      const pref: any = preferences?.find((p: any) => p.key === 'marginator');

      const levartiOrgIds = account?.levartiOrgIds;
      const levartiMarginator = account?.levartiMarginator;
      const isLevartiMarginator = levartiMarginator && items?.isTravelAgent && items?.organizationId && levartiOrgIds?.includes(items?.organizationId);

      if (pref || isLevartiMarginator) {
        let max, defaultValue, showSupplier;
        if (pref && !isLevartiMarginator) {
          max = JSON.parse(pref.value).max;
          defaultValue = JSON.parse(pref.value).defaultValue;
          showSupplier = JSON.parse(pref.value).showSupplier;
        } else {
          max = levartiMarginator?.max;
          defaultValue = levartiMarginator?.defaultValue;
          showSupplier = levartiMarginator?.showSupplier;
        }

        setMin(0);
        setMax(max);
        setShowSupplier(showSupplier);
        const newValue = marginatorStore.value !== 0 ? marginatorStore.value : defaultValue;
        setDefaultValue(newValue);
        dispatch(marginatorActions.setValue(newValue));
        dispatch(marginatorActions.setPercentage(newValue));
      }
    }
  }

  useEffect(() => handleSetShowMarginator(), [isAfterSearchLoad]);
  useEffect(() => handleSetShowMarginator(), [isAfterDetailsLoad]);
  useEffect(() => handleSetShowMarginator(), [hasReviewData]);
  useEffect(() => handleSetShowMarginator(), [isTravelAgentPro]);
  useEffect(() => setShowCommission(marginatorStore.showCommissionSelected), [marginatorStore.showCommissionSelected]);
  useEffect(() => setShowSupplierCheck(marginatorStore.showSupplierSelected), [marginatorStore.showSupplierSelected]);

  const handleChange = (value: number) => {
    setHasChanged(true);
    dispatch(marginatorActions.setValue(value));
  }

  const useMarginator = (apply: boolean) => {
    if (apply) {
      dispatch(marginatorActions.setPercentage(Number(marginatorStore.value)));

      dispatch(marginatorActions.showCommission(marginatorStore.showCommissionSelected));
      dispatch(marginatorActions.showSupplier(marginatorStore.showSupplierSelected));
    } else {
      if (hasChanged) {
        const value = Math.round(marginatorStore.percentage * 100);
        dispatch(marginatorActions.setPercentage(value));
        dispatch(marginatorActions.setValue(value));
        setDefaultValue(value);

        dispatch(marginatorActions.setShowCommissionSelected(marginatorStore.showCommission));
        dispatch(marginatorActions.setShowSupplierSelected(marginatorStore.showSupplier));
      }
    }
    setHasChanged(false);
    setShowDrop(false);
  }
  
  const handleSendEvent = (resutlCode: string, detailsCode: string, label: string) => {
    const isResultPage = isHotelResultPage || isCondoResultPage || isCarsResultPage;
    const isDetailsPage = isHotelDetailsPage || isCondoDetailsPage || isCarsDetailsPage;
    const action = isResultPage ? resutlCode : isDetailsPage ? detailsCode : null;
    if (action) {
      ReactGA.event({
        category: account?.name as string,
        action: `${action}_${account?.name.toUpperCase()}`,
        label,
        nonInteraction: false,
      });
    }
  }

  const handleShowDrop = (isOpen: boolean) => {
    handleSendEvent(TA_R_CLICK_GEAR, TA_D_CLICK_GEAR, `Travel agent clicked gear`);

    setShowDrop(isOpen);

    if (props.onOpen) {
      props.onOpen();
    }
  }

  const handleShowCommission = () => {
    handleSendEvent(TA_R_CLICK_SHOW_COMM, TA_D_CLICK_SHOW_COMM, `Travel agent clicked show commission`);

    setHasChanged(true);

    dispatch(marginatorActions.setShowCommissionSelected(!showCommission));
  }

  const handleShowSupplier = () => {
    handleSendEvent(TA_R_CLICK_SHOW_SUPPLIER, TA_D_CLICK_SHOW_SUPPLIER, `Travel agent clicked show supplier`);

    setHasChanged(true);

    dispatch(marginatorActions.setShowSupplierSelected(!showSupplierCheck));
  }

  const handleCancel = () => {
    handleSendEvent(TA_R_CLICK_CANCEL, TA_D_CLICK_CANCEL, `Travel agent clicked cancel button`);

    useMarginator(false);
  }

  const handleApply = () => {
    handleSendEvent(TA_R_CLICK_APPLY, TA_D_CLICK_APPLY, `Travel agent clicked cancel button`);

    useMarginator(true);
  }

  const handleAfterChange = () => {
    handleSendEvent(TA_R_CLICK_SLIDER, TA_D_CLICK_SLIDER, `Travel agent clicked the slider`);
  }

  const style = !isEmpty(headerFontColor) ? { color: headerFontColor } : {};

  if (isCapitalVacations) {
    return null;
  }

  return (
    <>
      {
        show &&
        <>
          <Dropdown align={'start'} drop={'down'} show={showDrop} className="marginator-dropdown" onToggle={(isOpen: boolean) => handleShowDrop(isOpen)} autoClose={false}>
            <Dropdown.Toggle className="btn-link btn-lg">
              <FontAwesomeIcon icon={faGear} style={style} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <div className='box'>
                <div className="row mt-2 mb-3">
                  <div className="col">
                    <p className="text-title"><FormattedMessage id="adjust.earnings" /></p>
                  </div>
                  <div className="col">
                    <Tooltip title={<small><FormattedMessage id="remember.adjust.earnings" /></small>} placement="topLeft">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Tooltip>
                  </div>
                </div>
                <div className="mb-3">
                  <Checkbox checked={marginatorStore.showCommissionSelected} onChange={handleShowCommission}>
                    <span className="text-title"><FormattedMessage id="show.commission" /></span>
                  </Checkbox>
                  {showSupplier &&
                    <Checkbox checked={marginatorStore.showSupplierSelected} onChange={handleShowSupplier}>
                      <span className="text-title"><FormattedMessage id="show.provider" /></span>
                    </Checkbox>
                  }
                </div>
                <div className="mt-3 mb-3">
                  <Slider
                    min={min}
                    max={max}
                    defaultValue={defaultValue}
                    tooltip={{ open: false }}
                    value={marginatorStore.value}
                    onAfterChange={handleAfterChange}
                    onChange={handleChange}
                  />

                  <div className="row percentage">
                    <div className="col text-left">%{min}</div>
                    <div className="col text-center">%{marginatorStore.value}</div>
                    <div className="col text-end">%{max}</div>
                  </div>
                </div>
                <div className="row buttons">
                  <div className="col">
                    <button type="button" className="btn btn-block btn-sm btn-link w-100" onClick={() => handleCancel()}><FormattedMessage id={'cancel'} /></button>
                  </div>
                  <div className="col">
                    <button type="button" className="btn btn-block btn-sm btn-primary w-100" onClick={() => handleApply()}><FormattedMessage id={'apply'} /></button>
                  </div>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </>
      }
    </>
  );
}
